<style scoped lang="less">
  .container{
    .select-box{
      display: flex;
      justify-content: space-around;
    }
    .pop {
      margin: 10px;
    }
    .pop-field {
      margin: 20px 0;
    }
    .pop-sub {
      margin-bottom: 15px;
    }
    .state-list{
      padding: 0;
      margin-bottom: 60px;
      li{
        list-style: none;
        text-align: left;
        border: 1px solid #e8e8e8;
        border-radius: 10px;
        padding: 0 20px;
        margin: 0 20px;
        margin-bottom: 20px;
        .status{
          span{
            float: right;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            padding: 2px 10px;
            font-size: 12px;
          }
        }
        .help{
          text-align: right;
        }
      }
    }
  }
</style>
<style>
  .select-box .mint-cell{
      min-height: 28px;
  }
</style>


<template>
  <div class="container">
    <div class="select-box">
      <!-- <mt-radio
        title="机器型号"
        v-model="model"
        :options="['全部','552', '4180', '5590']">
      </mt-radio> -->
      <mt-radio
        title="机器状态"
        v-model="value"
        :options="[
          {
            label: '全部',
            value: '全部',
          },
          {
            label: '正常',
            value: 'true',
          },
          {
            label: '故障',
            value: 'false',
          },
        ]">
      </mt-radio>
    </div>
    <ul class="state-list">
      <li v-for="state in filterStates">
        <p class="status">{{ state.status ? '正常' : '故障'  }}
          <span @click="showPopup(state.terminal_id)" >加纸签到</span >
        </p>
        <p class="step" v-if="!state.status">处理状态：{{state.dealWith || '未受理'}}</p>
        <p class="time" v-if="!state.status">报错时间：{{state.createAt}}</p>
        <p class="tag">机器类型：{{state.tags}}</p>
        <p class="location">地点：{{state.namecode}}</p>
        <p class="error" v-if="!state.status">具体问题：{{state.errorMsg}}</p>
        <!-- <p class="help" @click="changeHelp"><span>帮助</span></p> -->
      </li>
    </ul>
    <mt-popup
      v-model="showPop"
      popup-transition="popup-fade">
      <div class="pop">
        <div class="pop-field">
          <mt-switch v-model="tray1Filled">纸盒一已加满</mt-switch>
          <mt-switch v-model="tray2Filled">纸盒二已加满</mt-switch>
          <mt-switch v-model="tray3Filled">纸盒三已加满</mt-switch>
        </div>
        <div class="pop-sub">
          <mt-button @click.native="submit" class="btn">提交</mt-button>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations} from 'vuex'
import { getPoints, addPaper } from '../../../../service'

export default {
  name: 'State',
  data () {
    return {
      model: '全部',
      value: '全部',
      states: [],
      showPop: false,
      curTermId: 0,
      tray1Filled: false,
      tray2Filled: false,
      tray3Filled: false
    }
  },
  methods: {
    ...mapMutations({
        recordUser: "user/RECORD_USERINFO",
        changeHelp: "tab/CHANGE_HELP"
    }),
    changeHelp() {
      this.changeHelp(true);
    },
    async getList() {
          const { data } = await getPoints(this.tel);
          this.states = data.data;
    },
    formatGetTime: function(date) {
      return new Date(date).toLocaleString('chinese',{hour12:false}).slice(5,19).replace(/\//g,'-');
    },
    showPopup(id) {
      this.curTermId = id;
      this.showPop = true;
    },
    async submit() {
        let paper = 0;
        if (this.tray1Filled) {
          paper = paper + 500;
        }
        if (this.tray2Filled) {
          paper = paper + 500;
        }
        if (this.tray3Filled) {
          paper = paper + 500;
        }
        let req = {
          terminal: this.curTermId,
          paper: paper,
          photo: 0
        }
        await addPaper(req);
        this.showPop = false;
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
      ...mapGetters({
          tel: "user/tel"
      }),
    filterStates: function (){
          const data = this.states.filter((machine)=>(
            (this.model == '全部' || machine.tags == this.model) ? true : false
          )).filter((machine)=>(
            (this.value == '全部' || machine.status.toString() == this.value) ? true : false
          ));
          return data;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home/children/State/index.vue